import React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { useAuthCheck } from '../hook'
import { theme } from '../styles/theme'

export const NotFoundPage: React.FC = () => {
  const { checkAuth } = useAuthCheck()
  const getUrl = () => checkAuth('10000') ? 'upload' : checkAuth('0001') ? 'history' : 'user'
  return (
    <StyledPage>
      <div>
        <header>
          <strong>404</strong>
        </header>

        <p>존재하지 않는 페이지입니다</p>

        <Link to={getUrl()} replace>
          메인으로
        </Link>
      </div>
    </StyledPage>
  )
}

const StyledPage = styled.div`
  padding: 30px;
  display: flex;
  justify-content: center;
  align-items: center;

  & > div {
    display: grid;
    gap: 20px;

    & > header {
      display: flex;
      justify-content: center;
      align-items: end;
      gap: 30px;

      & > strong {
        font-size: 100px;
        font-weight: 700;
        line-height: 0.7;
      }
    }

    & > a {
      white-space: nowrap;
      background-color: ${theme.colors.green};
      color: ${theme.colors.white};
      padding: 10px;
      border-radius: 6px;
      width: min-content;
    }
  }
`
